/**
 * Helpers for the split booking bottom sheet
 */

import {SplitBookingOffer} from '@findhotel/sapi'
import {SplitBookingOfferInfo} from 'components/Offer/types'
import {getNumberOfNights} from 'utils/offers'

import {SearchOffer} from '@vio/core/src/offer/types/SearchOffer'

const MAX_SECONDARY_OFFERS_TO_SHOW = 2

/**
 *
 * @param offers - sapi split booking offers
 * @returns list of search split booking offer
 */
export const sapiSBOtoSearchSBO = (
  offers: SplitBookingOffer[]
): SplitBookingOfferInfo[] => {
  if (!offers) return []
  return offers.map(offer => ({
    offer: offer.offer as SearchOffer,
    checkIn: offer.checkIn,
    checkOut: offer.checkOut,
    nights: getNumberOfNights(offer.checkIn, offer.checkOut)
  }))
}
interface GetSecondaryOffersArgs {
  topOffers: SearchOffer[]
  hasSplitBookingOffer: boolean
  splitBookingPosition: number
  offerPositionToRemove: number | null
}
export const getSecondaryOffers = ({
  topOffers,
  hasSplitBookingOffer,
  splitBookingPosition,
  offerPositionToRemove
}: GetSecondaryOffersArgs) => {
  if (hasSplitBookingOffer) {
    if (topOffers?.length === 1 && splitBookingPosition === 1) return []

    const filtered = topOffers?.filter((_, i) => {
      // there's less than 3 offers, so we don't need to remove any
      if (offerPositionToRemove === null) return true

      // when the sb offer is the top offer, keep showing the top offer and remove the offer being replaced
      // because the top offer can be shown as secondary offers
      if (splitBookingPosition === 0) return i !== offerPositionToRemove

      // when the sb offer is not the top offer, remove the top offer and the offer being replaced
      // because the top offer is being shown as the primary offer
      return i !== 0 && i !== offerPositionToRemove
    })

    // when split booking is shown as a secondary offer, reserve a slot for it
    const maxRegularOffers =
      splitBookingPosition > 0
        ? MAX_SECONDARY_OFFERS_TO_SHOW - 1
        : MAX_SECONDARY_OFFERS_TO_SHOW

    return filtered?.slice(0, maxRegularOffers)
  }
  // Always return up to 2 offers
  // First offer is Primary offer so we start from index 1
  return topOffers?.slice(1, 3)
}
